"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
require("./styles.scss");
// @ts-ignore
const Configurator_js_1 = require("./configurator/Configurator.js");
document.addEventListener('DOMContentLoaded', () => {
    var _a;
    const configuratorElement = (_a = document.querySelector('#configurator')) === null || _a === void 0 ? void 0 : _a.closest('.product');
    if (null !== configuratorElement) {
        new Configurator_js_1.Configurator(configuratorElement);
    }
});
